import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=7dd998fe&scoped=true"
import script from "./grade.vue?vue&type=script&lang=ts"
export * from "./grade.vue?vue&type=script&lang=ts"
import style0 from "./grade.vue?vue&type=style&index=0&id=7dd998fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd998fe",
  null
  
)

export default component.exports